function normalizeNumbersForUi(value: any): any {
  if (Array.isArray(value)) return value.map(normalizeNumbersForUi);
  if (value && typeof value === "object") {
    const out: any = {};
    Object.keys(value).forEach((k) => {
      out[k] = normalizeNumbersForUi(value[k]);
    });
    return out;
  }
  return typeof value === "number" ? String(value) : value;
}

export function parseOutputValue(
  keyList: { value: string[] },
  initValue: { value: number },
  outputValue: string
): string {
  let json: any;
  try {
    let outputValueString = outputValue;

    // Encapsulating numeric values inside double quotes just for UI representation.
    outputValueString = outputValueString.replace(
      /(?<=:[\s]*|,[\s]*|^\s?)(-?\d+(\.\d+)?([eE][+-]?\d+)?)(?=[,}\]\s])/g,
      (match) => `"${match}"`
    );
    json = JSON.parse(outputValueString);
  } catch {
    // eg. on aws format: "content":"[{\"assetName\":\"abc.json\",\"ix\":1}
    try {
      json = normalizeNumbersForUi(JSON.parse(outputValue));
    } catch (error) {
      console.error("JSON parse error in parseOutputValue:", error);
      return outputValue;
    }
  }

  const obj = {};
  if (Array.isArray(json)) {
    json.forEach((item, index) => {
      obj[`[${index}]`] = item;
    });
  } else {
    keyList.value = Object.keys(json);
    keyList.value
      .slice(initValue.value, initValue.value + 30)
      .forEach((key) => {
        obj[key] = json[key];
      });
  }

  return JSON.stringify(obj);
}
